<template>
  <v-dialog v-model="show" scrollable width="50%" persistent>
    <v-card>
      <Toolbar
        title="Felhasználó módosítása"
        btn-title="Módosítás"
        @btnClicked="updateUser"
        @close="reset"
      />

      <v-card-text class="pt-3">
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="user.name"
                  label="Felhasználó neve"
                  required
                  :error-messages="getErrorMessage('name')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="user.email"
                  label="Email cím"
                  required
                  :error-messages="getErrorMessage('email')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="user.role"
                  label="Szerepkör"
                  :items="roles"
                  item-text="name"
                  return-object
                  :error-messages="getErrorMessage('role')"
                  @change="SET_USER_PERMISSIONS"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="user.permissions"
                  label="Jogosultságok"
                  :items="permissions"
                  item-text="name"
                  return-object
                  multiple
                  chips
                  small-chips
                  clearable
                  :error-messages="getErrorMessage('permissions')"
                >
                  <template #selection="{ item, index }">
                    <v-chip v-if="index < 2">
                      <span>
                        {{ item.name }}
                      </span>
                    </v-chip>
                    <span v-if="index === 2" class="grey--text caption">
                      {{ _selectedPermissionsText }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="user.password"
                  type="password"
                  label="Jelszó"
                  autocomplete="new-password"
                  :error-messages="getErrorMessage('password')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="user.password_confirmation"
                  type="password"
                  label="Jelszó megerősítése"
                  autocomplete="new-password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { SET_USER_PERMISSIONS } from "../../../utils/constants";
export default {
  name: "EditUserModal",
  computed: {
    ...mapGetters("Modal", {
      show: "showEditModal"
    }),
    ...mapGetters("User", ["user", "roles", "permissions"]),
    ...mapGetters(["getErrorMessage"]),
    _selectedPermissionsText() {
      if (this.permissions.length > 0) {
        const length = this.user.permissions.length - 2;
        return `(+${length} másik)`;
      }
      return "";
    }
  },
  methods: {
    ...mapActions("User", ["updateUser", "reset"]),
    ...mapMutations("User", [SET_USER_PERMISSIONS])
  }
};
</script>

<style></style>
